export const NeutralMarketTag = ({ regime, testId }) => {
  if ((regime?.regime || regime) !== "neutral") return null;
  return (
    <span
      className="text-[10px] font-semibold px-2 py-0.5 rounded-full ml-1 whitespace-nowrap"
      style={{ color: "var(--mb-ink-muted)", border: "1px solid var(--mb-border)" }}
      title="Fired while the overall market was neutral: the setup stood on its own, without a rising-market tailwind."
      data-testid={testId || "neutral-market-tag"}
    >
      Neutral market
    </span>
  );
};
